<template>
  <TabBar activeTabName="misc" />
  <div class="row justify-content-center px-0 mx-0">
    <NetworkServerMainList />
  </div>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component'
import NetworkServerMainList from '@/components/fleet/NetworkServerMainList.vue'
import NavigationService from '@/services/NavigationService'
import TabBar from '@/components/fleet/TabBar.vue'

@Options({
  components: {
    NetworkServerMainList,
    TabBar
  }
})
export default class NetworkServersList extends Vue {
  mounted () {
    NavigationService.setNavLevel2('Fleet', 'Networks', '#/fleet', '')
  }
}
</script>
